import React, { useRef } from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import InputWithIcon from "../../components/FormFields/InputWithIcon";
import CustomButton from "../../components/CustomButton";
import { icons } from "../../assets/icons";
import DatePicker from "../../components/FormFields/DatePicker";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import { toast } from "react-toastify";
import moment from "moment";
import { getBase64, sendToDBDateFormat } from "../../utils/helpers";
import { cashDepositValidation } from "../../utils/validations/cashDeposit";

const SubmitCashDeposit = () => {
  const { apiCall } = useApi();
  const filePickerRef = useRef([]);
  const navigate = useNavigate();
  const onClickAddMore = (values, setFieldValue) => {
    setFieldValue("documents", [
      ...values?.documents,
      {
        sales_day: new Date(),
        total_cash_sales: "",
        cash_deposit: "",
        comment: "",
        file: "",
      },
    ]);
  };

  const onSubmitRequest = async (values) => {
    const documents = await Promise.all(
      values?.documents.map(async (item) => {
        console.log(item, "itemmm");
        var filename = item?.file[0].name;
        let file = item?.file[0];
        const base64 = await getBase64(file);

        return {
          dataModalAttributeSet: [
            {
              attributeValue: moment(item?.sales_day).format(sendToDBDateFormat),
              metadataTechnicalName: "sales_day",
            },
            {
              attributeValue: item?.total_cash_sales,
              metadataTechnicalName: "total_cash_sales",
            },
            {
              attributeValue: item?.cash_deposit,
              metadataTechnicalName: "cash_deposit",
            },
            {
              attributeValue: item?.comment,
              metadataTechnicalName: "comment",
            },
          ],
          document: base64.split(",")[1],
          documentName: filename,
          metadataSchemaId: 8,
        };
      })
    );
    const dataToSend = {
      dataModalAttributeSet: [
        {
          attributeValue: values.description,
          metadataTechnicalName: "description",
        },
        {
          attributeValue: values.total_cash_deposit?.toString(),
          metadataTechnicalName: "total_cash_deposit",
        },
      ],
      documents,
      metadataSchemaId: 7,
    };

    apiCall({
      url: apiUrls.dmsService.createRecord,
      dataToSend,
      method: "post",
      onSuccess: () => {
        toast.success("Cash deposit has been submitted successfully");
        navigate(-1);
      },
    });
  };

  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="Submit Cash Deposit"
        showBack
        containerClassName="mt-14"
      />

      <Formik
        
        initialValues={{
          total_cash_deposit: "",
          description: "",
          documents: [
            {
              sales_day: new Date(),
              total_cash_sales: "",
              cash_deposit: "",
              comment: "",
              file: "",
            },
          ],
        }}
        validationSchema={cashDepositValidation}
        onSubmit={onSubmitRequest}
      >
        {({ errors, touched, values, setFieldValue }) => {
          return (
            <Form>
              <div className="flex flex-col mt-6">
                <div className="bg-[var(--whiteColor)] rounded-[1rem] min-h-[10rem] mt-3 flex flex-col justify-center px-4 py-6 gap-y-5">
                  {values?.documents.map((item, index) => {
                    return (
                      <div
                        className="flex items-cemter flex-col gap-x-4 gap-y-4"
                        key={"voucher-" + index}
                      >
                        <DatePicker
                          title={index === 0 && "Sales Day"}
                          onChange={(date) => {
                            let newDocuments = [...values?.documents];
                            newDocuments[index].sales_day = date;
                            setFieldValue("documents", newDocuments);
                          }}
                          startDate={values?.documents?.[index].sales_day}
                        />
                        <InputWithIcon
                          title={index === 0 && "Total Cash Sales (₹)"}
                          containerClassName="!bg-[var(--whiteColor)] border-[1px] border-[var(--borderGray1)] !h-[5rem]"
                          placeholder="Amount"
                          onChange={(e) => {
                            let newDocuments = [...values?.documents];
                            newDocuments[index].total_cash_sales = e;
                            setFieldValue("documents", newDocuments);
                          }}
                          type="number"
                          error={
                            touched?.documents?.[index]?.total_cash_sales &&
                            errors?.documents?.[index]?.total_cash_sales
                          }
                        />
                        <InputWithIcon
                          title={index === 0 && "Cash Deposit (₹)"}
                          containerClassName="!bg-[var(--whiteColor)] border-[1px] border-[var(--borderGray1)] !h-[5rem]"
                          placeholder="Amount"
                          onChange={(e) => {
                            let newDocuments = [...values?.documents];
                            newDocuments[index].cash_deposit = e;
                            setFieldValue("documents", newDocuments);
                            setFieldValue(
                              "total_cash_deposit",
                              values?.documents?.reduce(function (acc, obj) {
                                return acc + (Number(obj?.cash_deposit) || 0);
                              }, 0)
                            );
                          }}
                          type="number"
                          error={
                            // touched?.documents?.[index]?.cash_deposit &&
                            values.documents?.[index].cash_deposit > 0 &&
                            errors?.documents?.[index]?.cash_deposit
                          }
                        />
                        <InputWithIcon
                          title={index === 0 && "Comment"}
                          containerClassName="!bg-[var(--whiteColor)] border-[1px] border-[var(--borderGray1)] !h-[5rem]"
                          placeholder="Write Here"
                          onChange={(e) => {
                            let newDocuments = [...values?.documents];
                            newDocuments[index].comment = e;
                            setFieldValue("documents", newDocuments);
                          }}
                        />
                        <div>
                          {index === 0 && (
                            <div
                              className={`font-size-small text-[var(--blackColor)]`}
                            >
                              Attach File
                            </div>
                          )}
                          <CustomButton
                            title={item.file?.[0] ? "Uploaded" : "Upload"}
                            wrapperClassName="!h-[5rem] mt-2"
                            onClick={() => {
                              filePickerRef.current[index].click();
                            }}
                          />
                          <div
                            className={`font-size-small text-[var(--textRed)] mt-2`}
                          >
                            {touched?.documents?.[index]?.file &&
                              errors?.documents?.[index]?.file}
                          </div>
                          <input
                            type="file"
                            // accept="image/*"
                            accept=".pdf, .doc, .docx, .jpg, .jpeg, .png, .xls, .xlsx, .csv"
                            className="hidden"
                            onChange={async (e) => {
                              let newDocuments = [...values?.documents];
                              newDocuments[index].file = e.target.files;
                              setFieldValue("documents", newDocuments);
                            }}
                            ref={(el) => {
                              filePickerRef.current[index] = el;
                            }}
                          />
                        </div>
                        {index !== 0 && (
                          <span
                            className="self-center cursor-pointer"
                            onClick={() => {
                              let currentDocuments = [...values?.documents];
                              currentDocuments.splice(index, 1);
                              setFieldValue("documents", currentDocuments);
                              setFieldValue(
                                "total_cash_deposit",
                                currentDocuments?.reduce(function (acc, obj) {
                                  return acc + (Number(obj?.cash_deposit) || 0);
                                }, 0)
                              );
                            }}
                          >
                            <img
                              src={icons.trashIcon}
                              className="w-[2rem] h-[2.4rem]"
                              alt="delete icon"
                            />
                          </span>
                        )}
                      </div>
                    );
                  })}
                </div>

                <CustomButton
                  title="Add More Entry"
                  wrapperClassName="mt-6 border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-12 !w-[100%]"
                  onClick={() => onClickAddMore(values, setFieldValue)}
                />
                <div className="bg-[var(--whiteColor)] rounded-[1rem] min-h-[10rem] mt-14 px-6 py-6 pb-7">
                  <div className="flex items-center flex-col gap-y-5">
                    <InputWithIcon
                      title="Total Cash Deposit in INR(₹)"
                      wrapperClassName="!w-[100%]"
                      containerClassName="!w-[100% justify-center"
                      labelClassName="font-family-bold font-size-medium"
                      inputClassName="text-center font-family-medium !text-[3rem] !text-[var(--blackColor)] placeholder-[var(--blackColor)]"
                      disabled
                      value={Number(values?.total_cash_deposit).toFixed(2)}
                    />
                    <InputWithIcon
                      title="Description:"
                      containerClassName="!bg-[var(--whiteColor)] border-[1px] border-[var(--borderGray1)]"
                      labelClassName="font-family-bold font-size-medium"
                      placeholder="Write Here"
                      wrapperClassName="!w-[100%]"
                      onChange={(e) => {
                        setFieldValue("description", e);
                      }}
                      error={touched?.description && errors?.description}
                    />
                  </div>
                  <div className="text-[1.4rem] text-[var(--lightGray2)] mt-3">
                    Calculate automatically on added cash basis
                  </div>
                </div>
                <div className="flex flex-col mt-6 gap-y-4">
                  <div className="flex gap-x-5">
                    <CustomButton
                      title="Save"
                      type="submit"
                      wrapperClassName="!w-[100%]"
                    />
                    {/* <CustomButton
                      title="Send For Approval"
                      type="submit"
                      wrapperClassName="!w-[50%]"
                    /> */}
                  </div>
                  <CustomButton
                    title="Cancel"
                    wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent !text-[var(--blackColor)] !px-8"
                    onClick={() => {
                      navigate(-1);
                    }}
                  />
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default SubmitCashDeposit;
